import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { MODULE_IDS } from "../../constants/enums";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_MATERIAL_ALLOCATION_ROUTE } from "./MaterialAllocation.constants";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const MaterialAllocationList = Loadable(
  lazy(() =>
    import("./MaterialAllocationList").then(({ MaterialAllocationList }) => ({
      default: MaterialAllocationList,
    })),
  ),
);

export const materialAllocationRoutes = [
  {
    path: app_navbar_routes.app.material_allocation.project_wise,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess={true}
        moduleIds={[MODULE_IDS.MATERIAL_ALLOCATION]}
      >
        <MaterialAllocationList />
      </AuthorizedRoute>
    ),
  },
];
